var map = {
	"./about-region.jpg": "1fa5",
	"./aero.jpg": "3026",
	"./banner-interactive-card-map.jpg": "d2f5",
	"./billboard.png": "e211",
	"./bus-view-banner.jpg": "d89c",
	"./choose-municipality.jpg": "01f6",
	"./en.png": "6e4c",
	"./essentuki.jpg": "a133",
	"./excursions.jpg": "65a4",
	"./georgievsk.jpeg": "0f18",
	"./georgievsk.png": "0fd6",
	"./georgievsk_excursions.jpeg": "458f",
	"./georgievsk_excursions.jpg": "99e1",
	"./georgievsk_places.jpeg": "a216",
	"./georgievsk_places.jpg": "9b4d",
	"./georgievsk_routes.jpeg": "1f79",
	"./georgievsk_routes.jpg": "9685",
	"./gosuslugi-mobile.png": "2e5d",
	"./gosuslugi.png": "84af",
	"./guide-background.jpg": "9084",
	"./kislovodsk-excursions.jpg": "1a1d",
	"./kislovodsk-places.jpg": "888a",
	"./kislovodsk-trips.jpg": "322d",
	"./kislovodsk_logo.svg": "b95b",
	"./lermontov.png": "5284",
	"./minvody-excursions.jpg": "e493",
	"./minvody-logotype.svg": "515d",
	"./minvody-places.jpg": "b6d5",
	"./minvody-trips.jpg": "50f4",
	"./mobile-app.png": "8737",
	"./mobile.jpg": "6849",
	"./nevinnomyssk_logo.svg": "f536",
	"./panels.jpg": "b0a6",
	"./place-on-map.png": "ca59",
	"./places.jpg": "ffcc",
	"./pyatigorsk-logotype.svg": "b6f9",
	"./pyatigorsk-place.jpg": "f1de",
	"./qr.jpg": "7649",
	"./region-header.jpg": "e0ed",
	"./ru.png": "94dd",
	"./slide-0.jpg": "0f2c",
	"./slide-1.jpg": "1c4e",
	"./slide-2.jpg": "162e",
	"./slide-3.jpg": "07f4",
	"./slide-4.jpg": "a5b3",
	"./slide-5.jpg": "5928",
	"./sos.jpg": "4439",
	"./stavropol-excursions.png": "ab0b",
	"./stavropol-logotype.svg": "ea06",
	"./stavropol-places.jpeg": "6a0e",
	"./svg/ag-menu.svg": "10a3",
	"./svg/ag-mobile.svg": "4465",
	"./svg/ag.svg": "5ced",
	"./svg/anchor.svg": "93c7",
	"./svg/answer.svg": "9eac",
	"./svg/appstore.svg": "810e",
	"./svg/arrow-navigation.svg": "02f9",
	"./svg/arrow-slider-next.svg": "cf0c",
	"./svg/arrow-slider-preview.svg": "8bec",
	"./svg/back.svg": "f9f9",
	"./svg/backgroundSuccessfulObject.svg": "fee2",
	"./svg/bookmark-filled.svg": "63db",
	"./svg/bookmark.svg": "0f7a",
	"./svg/burger-menu.svg": "db1b",
	"./svg/bus.svg": "8be0",
	"./svg/calendar.svg": "670f",
	"./svg/cards.svg": "33db",
	"./svg/close.svg": "a2d7",
	"./svg/complexity.svg": "3ffe",
	"./svg/decor.svg": "e4c2",
	"./svg/duration.svg": "d1fa",
	"./svg/error.svg": "3a60",
	"./svg/excursion.svg": "18a7",
	"./svg/facebook-icon.svg": "9402",
	"./svg/fact.svg": "a1b3",
	"./svg/feedback.svg": "e6e6",
	"./svg/formation-portal-green.svg": "0dc4",
	"./svg/googleplay.svg": "04f6",
	"./svg/icon-close.svg": "ac49",
	"./svg/info-sos.svg": "59f6",
	"./svg/info.svg": "6dcc",
	"./svg/instagram-icon.svg": "46af",
	"./svg/label.svg": "9aef",
	"./svg/location-20.svg": "ec0a",
	"./svg/location.svg": "8d9f",
	"./svg/logotype-mini.svg": "1bd3",
	"./svg/logotype.svg": "7323",
	"./svg/logout.svg": "6839",
	"./svg/loupe.svg": "78e8",
	"./svg/map-icon.svg": "0c45",
	"./svg/map-marks.svg": "ebda",
	"./svg/map.svg": "bd33",
	"./svg/minus.svg": "2595",
	"./svg/mountains.svg": "2b41",
	"./svg/null-comment.svg": "564f",
	"./svg/object.svg": "7fed",
	"./svg/ok-icon.svg": "d675",
	"./svg/organization.svg": "9d6b",
	"./svg/pause.svg": "357d",
	"./svg/plane.svg": "38a8",
	"./svg/play.svg": "862f",
	"./svg/plus.svg": "0205",
	"./svg/rosatom.svg": "39ab",
	"./svg/route.svg": "0ec7",
	"./svg/search-bar-close.svg": "5887",
	"./svg/servis-ag.svg": "b807",
	"./svg/servis-data.svg": "3a05",
	"./svg/servis-government.svg": "393c",
	"./svg/servis-marketplace.svg": "a753",
	"./svg/servis-user.svg": "da92",
	"./svg/settings.svg": "605e",
	"./svg/sos.svg": "de9f",
	"./svg/star.svg": "db9f",
	"./svg/successfulFact.svg": "e9d2",
	"./svg/successfulObject.svg": "9b1b",
	"./svg/taxi.svg": "b8d7",
	"./svg/to-social-network.svg": "68eb",
	"./svg/train.svg": "cb45",
	"./svg/treasure-background.svg": "90eb",
	"./svg/twitter-icon.svg": "9051",
	"./svg/user.svg": "79c9",
	"./svg/vk-icon.svg": "baee",
	"./svg/youtube-icon.svg": "47c8",
	"./tomsk.png": "3788",
	"./trips-billboard.jpg": "1934",
	"./trips-top-background.jpg": "62f0",
	"./trips.jpg": "152c",
	"./zheleznovodsk-logotype.png": "b29d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";